<div class="row filter-type-selection-header">
  <div class="col-12">Companies owning a subsidiary</div>
</div>
<div class="row filter-type-selection-body">
  <div class="col-12">
    <div class="row">
      <div class="col-6">
        <p-table
          [value]="subsidiaryCharacteristics"
          [(selection)]="filter.subsidiaryCharacteristics"
          [scrollable]="true"
          (onRowSelect)="sortSelection(filter.subsidiaryCharacteristics)"
          styleClass="subsidiary-characteristics-table"
          dataKey="data"
        >
          <ng-template pTemplate="header">
            <tr>
              <th style="width: 3em" class="table-filter-row-header"><p-tableHeaderCheckbox></p-tableHeaderCheckbox>Type</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData>
            <tr [pSelectableRow]="rowData" class="table-filter-row-data">
              <td><p-tableCheckbox [value]="rowData"></p-tableCheckbox>{{ rowData.label }}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
      <div class="col-6">
        <p-tree
          [value]="filter.subsidiaryCharacteristics"
          (click)="formDirty = true"
          [(selection)]="filter.subsidiaryCharacteristics"
          selectionMode="multiple"
          selectionMode="checkbox"
          emptyMessage=" "
          styleClass="subsidiary-characteristics-table"
          key="data"
        ></p-tree>
      </div>
    </div>
    <div class="row">
      <div class="col=12">
        <span class="help-block">
          <span *ngIf="formDirty && (!this.filter.subsidiaryCharacteristics || this.filter.subsidiaryCharacteristics.length < 1)">
            Please select an option
          </span>
        </span>
      </div>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-4">
    <div class="form-group" [ngClass]="{ 'has-error': ShowValidationMessage(minimumPercent) }">
      <span class="ey-float-label">
        <input
          type="text"
          class="form-control"
          id="minimumPercent"
          name="minimumPercent"
          pattern="{{ regularExpressionPattern.NumberWithDecimalPattern }}"
          [(ngModel)]="filter.minimumPercent"
          [disabled]="readOnly"
          #minimumPercent="ngModel"
          maxlength="5"
          [appRequiredIf]="!filter.maximumPercent"
          appLabelFloat
        />
        <label for="minimumPercent">Minimum %</label>
      </span>
      <span class="help-block" *ngIf="minimumPercent.errors?.pattern"> Enter a valid percentage </span>
      <span class="help-block">
        <span *ngIf="ShowValidationMessage(minimumPercent) && minimumPercent.errors?.requiredIf && minimumPercent.errors?.requiredIf">
          Enter Minimum, Maximum, or both
        </span>
      </span>
    </div>
  </div>
  <div class="col-4">
    <div class="form-group" [ngClass]="{ 'has-error': ShowValidationMessage(maximumPercent) }">
      <span class="ey-float-label">
        <input
          type="text"
          class="form-control"
          id="maximumPercent"
          name="maximumPercent"
          pattern="{{ regularExpressionPattern.NumberWithDecimalPattern }}"
          [(ngModel)]="filter.maximumPercent"
          [disabled]="readOnly"
          #maximumPercent="ngModel"
          maxlength="5"
          [appRequiredIf]="!filter.minimumPercent"
          [appMin]="filter.minimumPercent"
          appLabelFloat
        />
        <label for="maximumPercent">Maximum %</label>
      </span>
      <span class="help-block" *ngIf="maximumPercent.errors?.pattern"> Enter a valid percentage </span>
      <span class="help-block">
        <span *ngIf="ShowValidationMessage(maximumPercent) && !CheckEndGreaterThanBeginning(filter.minimumPercent, filter.maximumPercent)">
          Maximum must be greater than Minimum
        </span>
      </span>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-12">
    <p-checkbox
      id="includeUnknownPercent"
      name="includeUnknownPercent"
      [(ngModel)]="filter.includeUnknownPercent"
      [disabled]="readOnly"
      binary="true"
    ></p-checkbox>
    <label for="includeUnknownPercent">Include subsidiaries with unknown percentage</label>
  </div>
</div>
